'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.graphs.gbuilder', {
            url: '/:graphId/graphBuilder?:copy',
            templateUrl: 'dashboard-graphBuilder/dashboard-graphBuilder.html',
            controller: 'dashboardGraphBuilderCtrl as ctrl',
            resolve: {
                myGraph: ['Graph', '$stateParams', 'graphFactory', 'toast', 'Authentication', '$translate', '$q', function (Graph, $stateParams, graphFactory, toast, Authentication, $translate, $q) {
                    if (Authentication.isAuthorized('supervisor')) {
                        console.log('No autorizado')
                        toast.errorNoTimeout($translate.instant("DASHBOARD.NO_AUTHORIZED"));
                    }

                    if ($stateParams.graphId === 'new') {
                        return graphFactory.new();
                    }

                    if (!$stateParams.graphId) {
                        toast.error($translate.instant("DASHBOARD.DASH_GRAPH.NOT_FOUND"));
                        return $q.reject("GRAPH_NOT_FOUND");
                    }

                    return Graph.find({
                        filter: {
                            "where": {
                                "id": $stateParams.graphId
                            }
                        }
                    })
                        .$promise
                        .then(function (dest) {
                            dest = dest && dest[0];
                            if (!dest || !dest.id) {
                                toast.error($translate.instant("DASHBOARD.DASH_GRAPH.NOT_FOUND"));
                                return $q.reject("GRAPH_NOT_FOUND");
                            }

                            // COPY OF DASH_GRAPH
                            if ($stateParams.copy === "true") {
                                delete dest.id;
                                delete dest.departmentId;
                                dest.name = $translate.instant("DASHBOARD.DASH_GRAPH.COPY_TEXT") + dest.name;
                            }
                            return graphFactory.load(dest);
                        }, function (error) {
                            console.log(error);
                            toast.error($translate.instant("DASHBOARD.DASH_GRAPH.NOT_FOUND"));
                            return $q.reject(error);
                        });
                }],
                forms: ['Department', '$stateParams', 'departments', '$state', 'Authentication', function (Department, $stateParams, departments, $state, Authentication) {
                    // console.log('llamado 4 Authentication.loadDepartments()')
                    return Authentication.loadDepartments().then(function(departments){
                        // console.log('loadDepartments', departments);
                        // console.log('$stateParams.departmentId', $stateParams.departmentId);
                        if (!$stateParams.departmentId && departments.length) {
                            let deptId = localStorage.getItem('lastDepartment');
                            let departmentExists = departments.find(dept => dept.id == deptId);
                            let targetDeptId = departmentExists ? deptId : departments[0].id;
                            return $state.go('dashboard.departments.department.forms', {
                                departmentId: targetDeptId
                            });
                        }
                        
                        // For department forms in graph
                        return departments.reduce(function (ret, item) {
                            return ret.concat(item.forms)
                        }, [])
                    });
                    
                }],
                departmentforms: ['Department', '$stateParams', 'departments', '$state', 'Authentication', function (Department, $stateParams, departments, $state, Authentication) {
                    // console.log('llamado 5 Authentication.loadDepartments()')
                    return Authentication.loadDepartments().then(function(departments) {
                        // console.log('departments', departments);
                        return departments;
                    });                    
                }],
                integrations: ['Integration', function(Integration) {
                    return Integration.find()
                    .$promise.then(function (integrations) {
                        // console.log("integrations", integrations)
                        return integrations;
                    });
                }],
                initializedData: ['myGraph', 'forms', 'integrations', 'departmentforms', 'graphDataFactory', function(myGraph, forms, integrations, departmentforms, graphDataFactory) {
                    graphDataFactory.init(forms, myGraph, integrations, departmentforms);
                    
                    // Retorna una promesa que se resuelve cuando todo está listo
                    return Promise.resolve({
                        myGraph: myGraph,
                        forms: forms,
                        integrations: integrations,
                        departmentforms: departmentforms,
                        initialized: true
                    });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
